import { Controller } from "@hotwired/stimulus"

// Diagnostic UX for /problemas show pages: symptom pick + sticky hire CTA.
export default class extends Controller {
  static targets = ["symptom", "symptomNote", "hireBar", "revealSentinel"]

  connect() {
    this.selectedSymptom = null
    this.setupObserver()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  selectSymptom(event) {
    event.preventDefault()
    const button = event.currentTarget
    const label = button.dataset.symptomLabel

    this.symptomTargets.forEach((el) => {
      const active = el === button
      el.classList.toggle("border-emerald-500", active)
      el.classList.toggle("bg-emerald-50", active)
      el.classList.toggle("text-emerald-900", active)
      el.classList.toggle("ring-2", active)
      el.classList.toggle("ring-emerald-200", active)
      el.setAttribute("aria-pressed", active ? "true" : "false")
    })

    this.selectedSymptom = label
    if (this.hasSymptomNoteTarget) {
      this.symptomNoteTarget.hidden = false
      this.symptomNoteTarget.querySelector("[data-selected-label]").textContent = label
    }

    const next =
      document.getElementById("problema-causas") ||
      document.getElementById("problema-urgente")
    if (next) next.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  setupObserver() {
    if (!this.hasHireBarTarget || !this.hasRevealSentinelTarget) return

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0
        this.hireBarTarget.classList.toggle("translate-y-full", !show)
        this.hireBarTarget.classList.toggle("opacity-0", !show)
        this.hireBarTarget.setAttribute("aria-hidden", show ? "false" : "true")
      },
      { threshold: 0 },
    )

    this.observer.observe(this.revealSentinelTarget)
  }
}
